<template>
  <el-row class="container">
    <HeaderComponent></HeaderComponent>
    <el-col :span="24" class="main">
      <SidebarComponent></SidebarComponent>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col
            :span="24"
            class="breadcrumb-container"
            v-if="showBreadcrumbs"
          >
            <strong class="title">{{ $route.name }}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item
                v-for="item in $route.matched"
                :key="item.path"
              >
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="el-fade-in-linear" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SidebarComponent from '@/components/SidebarComponent'

export default {
  data() {
    return {
      showBreadcrumbs: false
    }
  },
  components: {
    HeaderComponent,
    SidebarComponent
  }
}
</script>

<style scoped lang="scss">
.container {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;

  .main {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100vh;
    background: #f3f3f4;

    .content-container {
      margin-left: 220px;
      flex: 1;
      padding: 30px 30px;

      .breadcrumb-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 30px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
